export default (() => {
  if(!$('.entrytype-course-v2').length){
    return
  }

  // Feature detect and hide the version we dont need
  if(navigator.share){
    $('.actions__share').hide()
  } else {
    $('.actions__share-native').hide()
  }

  $(function(){

    // Native share (mobile)
    const shareEl = $('.actions__share-native');
    shareEl.on('click', async () => {
      try {
        console.log('init native share')

        const share = await navigator.share({
          url: shareEl.data('url'),
          title: shareEl.data('title')
        })

      } catch (e){
        console.log('error with native share', e)
      }

    })
  })
})()
